import React, { lazy, Suspense } from "react";
import LazyLoader from "../../components/common/loader/lazyLoader";
const AddBrandWiseB2G1Offers = lazy(() =>
  import("../../components/setOffers/brandB2G1")
);

const BrandB2G1Page = () => {
  return (
    <Suspense fallback={<LazyLoader />}>
      <AddBrandWiseB2G1Offers />
    </Suspense>
  );
};

export default BrandB2G1Page;
